var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodeli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.561.446H.271v41.475h81.29V.446z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.991 27.487V14.882H.271v12.605h1.765v-11.06h7.233v11.06h1.722zM55.638 21.81c.014-.208.028-.417.028-.626a7.3 7.3 0 0 0-.071-.974c-.484-3.2-3.303-5.662-6.72-5.662-3.745 0-6.791 2.977-6.791 6.636 0 3.66 3.046 6.637 6.79 6.637 2.962 0 5.468-1.85 6.408-4.425H53.43c-.826 1.642-2.563 2.755-4.556 2.755-2.592 0-4.741-1.892-5.054-4.355l11.817.014zm-6.763-5.593c2.463 0 4.527 1.726 4.997 4.007h-9.98c.455-2.295 2.505-4.007 4.983-4.007zM40.518 25.915 35.876 15.73a1.456 1.456 0 0 0-1.338-.85c-.584 0-1.11.335-1.338.85l-4.642 10.184h-1.58v1.572h15.134v-1.572h-1.594zm-5.98-9.141 4.072 9.14h-8.144l4.072-9.14zM68.621 27.487l-5.068-11.743a1.435 1.435 0 0 0-1.324-.848 1.45 1.45 0 0 0-1.325.848l-5.082 11.743h1.907l4.485-10.616 4.5 10.616h1.907zM79.825 14.882h-.029l-7.688 10.212V14.882h-1.737v12.605h1.737l7.717-10.24v10.24h1.737V14.88h-1.737zM20.116 14.548c-3.758 0-6.79 2.977-6.79 6.636 0 3.66 3.046 6.637 6.79 6.637 3.76 0 6.792-2.978 6.792-6.637 0-3.659-3.047-6.636-6.792-6.636zm0 11.617c-2.804 0-5.097-2.226-5.097-4.98 0-2.755 2.278-4.982 5.097-4.982 2.82 0 5.097 2.227 5.097 4.981 0 2.755-2.292 4.981-5.097 4.981z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.116 15.438a.83.83 0 0 0 .726.821c2.236.306 4.001 2.032 4.314 4.216.057.403.427.71.84.71a.838.838 0 0 0 .84-.947c-.427-2.907-2.79-5.217-5.766-5.62a.832.832 0 0 0-.954.82z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.27)",
    d: "M0 0h81.291v42.304H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodeli);
export default __webpack_public_path__ + "static/media/podeli.77b881848f4d32aaa74114f8c800545f.svg";
export { ForwardRef as ReactComponent };